import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Stack,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Link
} from "@mui/material";
import { Avatar } from "primereact/avatar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useNavigate, useLocation } from "react-router-dom"; // if you use react-router for navigation
import "./Header.css";
import logo from "../assests/Aays_Logo_White (1).webp";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import marsIcon from "../assests/snackingRingLogo.png"
import { ShoppingCart } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { CLEAR_CART } from "../redux/domainAddToCart/domainAddToCart.type";
import CartSubscriptionModal from "../component/Layout/Domain/CartSubscriptionModal";
import { toast, Toaster } from "react-hot-toast";

import Tooltip from '@mui/material/Tooltip';
import axios from "axios";
import UserGuideMenu from "../component/common/UserGuideMenu";
import { useAuth } from "../context/AuthContext";

const Header = () => {
  const { authUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null); // anchor element for menu
  const [userRole, setUserRole] = useState("");
  const open = Boolean(anchorEl);
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const name = account?.name || "User";
  const email = account?.username || "user@effem.com";
  const [photo, setPhoto] = useState(null);

  // Cart functionality
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.domainAddToCart);

  // Subscription form state
  const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);
  const [formTouched, setFormTouched] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [subscriptionForm, setSubscriptionForm] = useState({
    productName: "",
    projectCode: "",
    readerGroup: "",
    usageDuration: "3months",
    usageDescription: "",
    notificationEmail: "",
    acceptTerms: false,
    source: "DATAPULSE",
  });
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [allFieldsValid, setAllFieldsValid] = useState(true);


  console.log("Account Details:", account);

  const getProfilePhoto = async () => {
    try {
      // Ensure you acquire a token for the signed-in user
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0], // Use the first account from the authenticated accounts
      });

      const token = response.accessToken;

      // Fetch the profile photo
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
          },
          responseType: "arraybuffer", // To receive the image as binary data
        }
      );

      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setPhoto(imageUrl);
      if(imageUrl){
        localStorage.setItem("profilePhoto", imageUrl);
      }

    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };


  useEffect(() => {
    getProfilePhoto();
  }, []);

  useEffect(() => {
    if (authUser?.role) {
      setUserRole(authUser.role);
    }
  }, [authUser]);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Your logout logic here
    console.log("Logout clicked");
    handleClose();
  };

  const handleSubscribe = () => {
    setShowSubscriptionForm(true);
  };

  const closeSubsciptionModal = () => {
    setFormTouched(false);
    setShowSubscriptionForm(false);
    setSubscriptionForm({
      productName: "",
      projectCode: "",
      readerGroup: "",
      usageDuration: "3months",
      usageDescription: "",
      notificationEmail: "",
      acceptTerms: false,
      source: "DATAPULSE",
    });
  };

  const handleSubscriptionChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    let _form = {
      ...subscriptionForm,
      [name]: newValue,
    };
    // populate reader group if exists
    if (name === "productName") {
      _form.readerGroup = e.target.readerGroup || "";
      _form.source = e.target.source || "DATAPULSE";
    }
    setSubscriptionForm(_form);
  };

  return (
    <AppBar
      position="static"
      className="main-header"
      sx={{
        backgroundColor: "#000",
        height: "92px",
        justifyContent: "center",
        // background: "linear-gradient(90deg, #fff 0%, #fff 100%)",
        // borderBottom: '1px solid #eee',
        outline: 'none',
        boxShadow: 'none'

      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", }}>
        {/* Logo */}
        <Box sx={{ px: 2, py: 1, display: "flex", gap: "20px", justifyContent: "flex-start", alignItems: "center"}}>
          <img src={logo} alt="logo" width={110} />
        </Box>

        <Box sx={{display: "flex", gap:"10px", alignItems: "center"}}>
          <div className="flex items-center gap-4 ">
            <UserGuideMenu />
          </div>

          <div
            style={{
              height: "20px",
              paddingLeft: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Tooltip
              title="Opens the production Feature Requests with a redirect notice"
              placement="bottom"
            >
              <Link
                href="/feature-requests"
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  textDecoration: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  color: "inherit",
                }}
              >
                <ChatBubbleOutlineIcon
                  sx={{ color: "#bb1ccc", fontSize: 18 }}
                />
                <span className="hidden sm:inline text-[#fff]">Leave feedback</span>
              </Link>
            </Tooltip>


          </div>
          <div class="w-px h-6 bg-gray-300"></div>

          {/* Cart Button */}
          {(location.pathname === "/") && cartItems && cartItems?.length > 0 && (
            <button
              onClick={handleSubscribe}
              className="border-2 border-teal-400 text-teal-400 text-[9px] sm:text-[12px] h-[32px] rounded-lg px-2 sm:px-4 py-1 flex items-center gap-1.5 whitespace-nowrap bg-white hover:bg-teal-50 transition-colors"
            >
              <ShoppingCart className="h-4 sm:h-[20px]" />
              <span className="hidden sm:inline sm:text-sm font-semibold">Cart ({cartItems?.length || 0})</span>
              <span className="sm:hidden text-[8px]">Cart ({cartItems?.length || 0})</span>
            </button>
          )}

          <div className="flex items-center gap-2">


            <Avatar
            image={photo ? photo : null}
            data-pr-tooltip={name || "User"}
            style={{
              verticalAlign: "top",
              position: "relative",
              backgroundColor: "#6366F1",
              color: "white",
              fontWeight: "bold",
              height: "35px",
              width: "35px",
              cursor: "pointer",
            }}
            onClick={handleAvatarClick}
            shape="circle"
          >
            {photo ? "" : name?.charAt(0).toUpperCase() || 'U'}
          </Avatar>

            </div>
          </Box>


        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem>
              {name}
            </MenuItem>
              <MenuItem>
              <span style={{ overflowWrap: "anywhere" }}>
                {email}
              </span>
            </MenuItem>
            {userRole === "Admin" && (
              <MenuItem
                onClick={() => {
                  navigate("/userManagement");
                  handleClose();
                }}
              >
                User Management
              </MenuItem>
            )}
            <MenuItem onClick={handleLogout}>Logout</MenuItem>

          </Menu>
      </Toolbar>

      {/* Cart Subscription Modal */}
      {showSubscriptionForm && (
        <CartSubscriptionModal
          cartItems={cartItems}
          subscriptionForm={subscriptionForm}
          closeSubsciptionModal={closeSubsciptionModal}
          handleSubscriptionChange={handleSubscriptionChange}
          setShowSubscriptionForm={setShowSubscriptionForm}
          showSubscriptionForm={showSubscriptionForm}
          allFieldsValid={allFieldsValid}
          formTouched={formTouched}
          formErrors={formErrors}
          subscriptionLoading={subscriptionLoading}
          setSubscriptionLoading={setSubscriptionLoading}
        />
      )}

      <Toaster />
    </AppBar>
  );
};

export default Header;
 